
export const getApiBaseUrl = () => {
    // Check if we are in development environment (localhost)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost/tecnosmx.com/admin/api';
    }

    // Production environment - relative path
    return '/admin/api';
};


export const getImageBaseUrl = () => {
    // Check if we are in development environment (localhost)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost/tecnosmx.com';
    }

    // Production environment - relative path
    return '';
};

export const API_BASE_URL = getApiBaseUrl();
export const IMAGE_BASE_URL = getImageBaseUrl();
